<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Merchant Map</h1>
            <hr>
            <mdb-row>
                <mdb-col col="4" class="flex-row">
                    <mdb-btn size="sm" @click="toggleActive" :color="show_active?'success':'grey'"><img src="http://maps.google.com/mapfiles/ms/icons/green-dot.png" style="height: 15px; width: 15px;" /> Online</mdb-btn>
                    <mdb-btn size="sm" @click="toggleInactive" :color="show_inactive?'success':'grey'"><img src="http://maps.google.com/mapfiles/ms/icons/red-dot.png" style="height: 15px; width: 15px;" /> Offline</mdb-btn>
                </mdb-col>
                <mdb-col col="8" class="flex-row">
                    <mdb-spinner v-if="sync_loading" class="p-0 m-0" small color="blue"/>
                    <mdb-btn size="sm" v-if="!sync_loading" @click="synchronizeMerchantZone" color="primary">Synchronize Merchant Zone</mdb-btn>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col col="10">
                    <div id="map" />
                </mdb-col>
                <mdb-col col="2" class="scrollable-merchant-list">
                    <div @click="animateMerchant(merchant)" class="merchant-click" v-for="merchant in merchants" v-bind:key="merchant.id">{{merchant.name}}</div>
                </mdb-col>
            </mdb-row>
            <p class="text-danger">This map cost google map API. $7 per 1000 requests</p>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbBtn, mdbRow, mdbCol, mdbSpinner } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
// import {APP_FILE_URL} from '../js/config';

export default {
    name: 'merchant_map',
    components: {
        mdbContainer, mdbBtn, mdbRow, mdbCol,
        AppNavigation, mdbSpinner
    },
    data: ()=>({
        loading: false,
        map: null,
        active_markers: [],
        inactive_markers: [],
        merchants : [],
        show_active: true,
        show_inactive: true,
        zones: [],
        sync_loading: false,
    }),
    methods: {
        getData(){
            if(this.loading){
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/get_merchant_map",
                complete: ()=>this.loading=false,
                success: result=>{
                    this.merchants=result.data.merchants;
                    this.zones=result.data.zones;
                    this.renderMap();
                },
            }, this)
        },
        renderMap(){
            const google = window.google;
            if(!this.map){
                var mapProp = {
                    center:new google.maps.LatLng(2.2764785,102.8828676),
                    zoom:8,
                };
                this.map=new google.maps.Map(document.getElementById("map"),mapProp);

                this.merchants.forEach((element, index) => {
                    let merchant_point = new google.maps.LatLng(element.lat,element.lng);
                    var merchant_marker = new google.maps.Marker({
                        position: merchant_point,
                        title:element.name,
                        animation: google.maps.Animation.DROP
                    });
                    if(element.is_active==1){
                        merchant_marker.setIcon('https://maps.google.com/mapfiles/ms/icons/green-dot.png')
                        this.active_markers.push(merchant_marker);
                    }else{
                        merchant_marker.setIcon('https://maps.google.com/mapfiles/ms/icons/red-dot.png')
                        this.inactive_markers.push(merchant_marker);
                    }
                    google.maps.event.addListener(merchant_marker, 'click', function() {
                        sessionStorage.setItem('merchant_name', element.name);
                        window.open('/merchant_list');
                    });
                    setTimeout(()=>{
                        merchant_marker.setMap(this.map);
                    }, index*10)
                });
                setTimeout(()=>{
                    this.zones.forEach(zone=>{
                        zone.zone_coverage.forEach(coverage=>{
                            const coverage_geolocation = [
                                { lat: parseFloat(coverage.lat_1), lng: parseFloat(coverage.lng_1) },
                                { lat: parseFloat(coverage.lat_2), lng: parseFloat(coverage.lng_2) },
                                { lat: parseFloat(coverage.lat_3), lng: parseFloat(coverage.lng_3) },
                                { lat: parseFloat(coverage.lat_4), lng: parseFloat(coverage.lng_4) },
                            ];
                            // Construct the polygon.
                            const coverage_map = new google.maps.Polygon({
                                paths: coverage_geolocation,
                                strokeColor: zone.color,
                                strokeOpacity: 0.3,
                                strokeWeight: 1,
                                fillColor: zone.color,
                                fillOpacity: 0.3,
                                editable: false
                            });                
                            coverage_map.setMap(this.map); 
                        })
                    })
                }, this.merchants.length*10)
            }
        },
        toggleActive(){
            if(this.show_active){
                this.active_markers.forEach(marker=>{
                    marker.setMap(null);
                })
                this.show_active=false;
            }else{
                this.active_markers.forEach(marker=>{
                    marker.setMap(this.map);
                })
                this.show_active=true;
            }
        },
        toggleInactive(){
            if(this.show_inactive){
                this.inactive_markers.forEach(marker=>{
                    marker.setMap(null);
                })
                this.show_inactive=false;
            }else{
                this.inactive_markers.forEach(marker=>{
                    marker.setMap(this.map);
                })
                this.show_inactive=true;
            }
        },
        animateMerchant(merchant){
            const google = window.google;
            this.map.setZoom(15);
            this.map.panTo(new google.maps.LatLng(merchant.lat, merchant.lng));
        },
        synchronizeMerchantZone(){
            if(this.sync_loading){
                return false;
            }
            this.sync_loading=true;
            ajax({
                url: "admin/synchronize_merchant_zone",
                success: ()=>{
                    this.$notify.success({message: 'Synchronized Completed', position:'top right', timeOut: 5000});
                },
                complete: ()=>this.sync_loading=false
            }, this)
        }
    },
    mounted: function(){
        this.getData();
    }
}
</script>

<style scoped>
#map{
    width: 100%;
    height: 65vh;
}
.scrollable-merchant-list{
    height: 65vh;
    overflow: scroll;
}
.merchant-click{
    border-bottom: 1px solid #bdbdbd;
    margin-bottom: 5px;
    cursor: pointer;
}
.merchant-click:hover{
    font-weight: bold;
}
</style>
